import { Media } from './media';

export class ProductPage {
    public key: string = '';
    public title: string = '';
    public subTitle: string = '';
    public media: Media = null;
    public price: number = 0;
    public language: 'da' | 'en' = 'en';
    public sections: ProductPageSection[] = [];
    public relatedTourKey: string = '';
    public productKey: string = '';

    constructor(key: string, json: any = null) {
        this.key = key;
        if(json) this.fromJson(json);
    }

    public fromJson(json): ProductPage {
        this.title = json.title || '';
        this.subTitle = json.subTitle || '';
        this.relatedTourKey = json.relatedTourKey || '';
        this.productKey = json.productKey || '';
        if(json.media) this.media = new Media(json.media);
        this.language = json.language || 'en';
        if(!json.sections) return this;

        let sections: ProductPageSection[] = [];
        json.sections.forEach((jsonSection) => {
            sections.push(new ProductPageSection(jsonSection));
        });
        this.sections = sections;
        return this;
    }
}

export enum ProductPageSectionType {
    ICON = 'icon',
    TEXT = 'text'
}

export class ProductPageSection {
    public title: string = '';
    public paragraphs: string[] = [];
    public icons: string[] = [];
    public cta: string = '';
    public ctaType: 'buy' | 'trailer' = 'trailer';
    public media: Media = null;
    public type: ProductPageSectionType = ProductPageSectionType.TEXT;
    public align: 'left' | 'middle' | 'right' = 'left';
    public backgroundType: 'video' | 'image' | 'none' = 'image';
    public mediaArray: Media[] = [];

    constructor(json: any = null) {
        if(json) this.fromJson(json);
    }

    public fromJson(json): ProductPageSection {
        this.title = json.title || '';
        this.cta = json.cta || '';
        this.ctaType = json.ctaType || 'trailer';
        this.paragraphs = json.paragraphs || '';
        if(json.media) this.media = new Media(json.media);
        this.icons = json.icons || [];
        this.type = json.type || ProductPageSectionType.TEXT;
        this.align = json.align || 'left';
        this.backgroundType = json.backgroundType || 'image';
        if(!json.mediaArray) return this;

        let mediaArray: Media[] = [];
        json.mediaArray.forEach((jsonMedia) => {
            mediaArray.push(new Media(jsonMedia));
        });
        this.mediaArray = mediaArray;
        return this;
    }
}
